import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  loaderService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
} from 'app/components/global';
import emergencyProcedure from './emergencyProcedure';
import editEmergencyProcedureDialog from './emergencyProcedure/dialog.editEmergencyProcedureDialog';
import controller from './emergency-plan.controller';
import directive from './emergency-plan.directive';

export default angular.module('app.components.advisory.bcp.emergencyPlan', [
  alerts,
  bcpDataService,
  constants,
  loaderService,
  ssDialogService,
  userService,
  emergencyProcedure,
  editEmergencyProcedureDialog,
])
  .directive('bcpEmergencyPlan', directive)
  .controller('EmergencyPlanController', controller)
  .name;

console.log('app.components.advisory.bcp.emergencyPlan created');
